import type { WithCollections } from '@pressreader/social-types';

function isCollectionNotEmpty(bookmarkCollections: WithCollections): boolean {
    return bookmarkCollections.collections && bookmarkCollections.collections.length > 0;
}

export { isCollectionNotEmpty };
